import 'css-chunksrc/client/scenes/moveElement/projectsSelection/zones/zone/projects/styles.scss';export default {
  "projects": "_projects_1msvi_1"
};